import webkit_line_clamp from 'webkit-line-clamp';

export default {
    init() {
        let large_article = document.querySelectorAll('.article-large__content h4');
        this.clamp(large_article, 2);
        let large_article_height = this.get_max_height(large_article);
        if(large_article_height !== false) {
            this.set_height(large_article, large_article_height);
        }
        let article = document.querySelectorAll('.article__content h4');
        this.clamp(article, 3, 767)
        let article_height = this.get_max_height(article, 767);
        if(article_height !== false) {
            this.set_height(article, article_height, 767);
        }

        //setting image to smallest one.
        let article_images = document.querySelectorAll('.article__image .main');
        setTimeout(() => {
            let article_image_height = this.get_max_height(article_images, 767);
            if(article_image_height !== false) {
                this.set_height(article_images, article_image_height, 767)
            }
        }, 200)

        let bullet_points = document.getElementsByClassName('bullet-points__item');
        let bullet_points_height = this.get_max_height(bullet_points);
        if(bullet_points_height !== false) {
            this.set_height(bullet_points, bullet_points_height);
        }

        let headers = document.querySelectorAll('.header-column .header-content .table__height');
        let headers_height = this.get_max_height(headers);
        if(headers_height !== false) {
            this.set_height(headers, headers_height);
        }
    },

    clamp(els, lines, mobile_width = 1000) {
        if(window.innerWidth > mobile_width && els) {
            if(els.length > 0) {
                for(let i = 0; i < els.length; i++) {
                    let el = els[i];
                    webkit_line_clamp(el, lines)
                }
            }
        }
    },

    get_min_height(els, min_width = 767, max_width = 1201) {
        if(window.innerWidth > min_width && window.innerWidth < max_width && els) {
            if(els.length > 0) {
                let curr_height = 10000;
                for(let i = 0; i < els.length; i++) {
                    let el = els[i];
                    if(el.offsetHeight < curr_height) {
                        curr_height = el.offsetHeight
                    }
                }

                return curr_height + "px";
            }
        }

        return false;
    },

    /**
     * Getting the maximum height of a given set of HTMLElements to later resize.
     * @param {Array.HTMLElement} els List of the elements that we wish to get the maximum size of.
     * @param {number} ignore_mobile Width at which we should not do this.
     * @returns {string|bool} Either false if no elements or the number to set height to in px.
     */
    get_max_height(els, mobile_width = 1000) {
        if(window.innerWidth > mobile_width && els) {
            if(els.length > 0) {
                let curr_height = 0;
                for(let i = 0; i < els.length; i++) {
                    let el = els[i];
                    if(el.offsetHeight > curr_height) {
                        curr_height = el.offsetHeight
                    }
                }

                return curr_height + "px";
            }
        }

        return false;
    },

    set_height(els, height, mobile_width = 1000) {
        if(window.innerWidth > mobile_width && els) {
            if(els.length > 0) {
                for(let i = 0; i < els.length; i++) {
                    let el = els[i];
                    el.style.height = height;
                }
            }
        }
    }
}